import React, { PureComponent, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Footer from '@ifeng-fe/container_channel/common/client/summer/components/pc/footer';
import Header from './header';
import Nav from './nav';
import Slide from './slide';
import News from './news';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
const ContentNav = errorBoundary(props => {
    const { content, classname } = props;

    return (
        <div className={`${styles.title} ${classname}`}>
            <a href={content.moreUrl} target="_blank" className={styles.more} />
        </div>
    );
});

const Report = errorBoundary(props => {
    return (
        <div className={styles.report_container}>
            {props.content.map((item, index) => {
                return (
                    <div className={styles.report_item} key={index}>
                        <img
                            src={item.thumbnail}
                            onClick={_ => {
                                window.open(item.url);
                            }}
                        />
                        <a href={item.url} target="_blank">
                            {item.title}
                        </a>
                    </div>
                );
            })}
        </div>
    );
});

const LeftImgContent = errorBoundary(props => {
    const { style, content } = props;

    return (
        <div className={styles.column_item} style={style}>
            <div
                className={styles.column_title}
                onClick={_ => {
                    window.open(content.url);
                }}>
                {content.title}
            </div>
            <div className={styles.img_item}>
                <img
                    src={content.src}
                    onClick={_ => {
                        window.open(content.url);
                    }}
                />
                <div className={styles.content}>
                    <div className={styles.small_title}>{content.timeAddr}</div>
                    <div className={styles.text}>
                        {content.description}
                        <a href={content.url} target="_blank">
                            详情 &gt;
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
});

const RightImgContent = errorBoundary(props => {
    const { style, content } = props;

    return (
        <div className={styles.column_item} style={style}>
            <div
                className={styles.column_title}
                onClick={_ => {
                    window.open(content.url);
                }}>
                {content.title}
            </div>
            <div className={styles.img_item}>
                <div className={styles.content}>
                    <div className={styles.small_title}>{content.timeAddr}</div>
                    <div className={styles.text}>
                        {content.description}
                        <a href={content.url} target="_blank">
                            详情 &gt;
                        </a>
                    </div>
                </div>
                <img
                    src={content.src}
                    onClick={_ => {
                        window.open(content.url);
                    }}
                />
            </div>
        </div>
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            content: {
                footer,
                headerImg,
                headNav,
                phMedia,
                videoInfo,
                leadNews,
                leadNewsInfo,
                importantNews,
                reportNav,
                voiceNav,
                talkNav,
                mediaNav,
                report,
                voice1,
                voice2,
                talk1,
                talk2,
                media1,
                media2,
            },
        } = this.props;

        return (
            <div className={styles.lcl_container}>
                <Chip id="230099" type="struct" title="顶部图片" groupName="head" content={headerImg}>
                    <Header />
                </Chip>
                <Chip id="200092" type="struct" title="导航" groupName="head" content={headNav}>
                    <Nav />
                </Chip>
                <Chip id="170114" type="struct" title="全媒体" groupName="content" content={phMedia}>
                    <Slide />
                </Chip>
                <News
                    videoInfo={videoInfo}
                    leadNews={leadNews}
                    leadNewsInfo={leadNewsInfo}
                    importantNews={importantNews}
                />
                <div id="act_report" className={styles.column}>
                    <Chip id="200093" type="struct" title="活动报道导航" groupName="content" content={reportNav}>
                        <ContentNav classname={styles.reports} />
                    </Chip>
                    <Chip id="195100" type="recommend" title="活动报道" groupName="content" content={report}>
                        <Report />
                    </Chip>
                </div>
                <div id="lecture_voice" className={styles.column}>
                    <Chip id="170115" type="struct" title="演讲声音导航" groupName="content" content={voiceNav}>
                        <ContentNav classname={styles.lecture} />
                    </Chip>
                    <div className={styles.columnList}>
                        <Chip id="230101" type="struct" title="演讲声音1" groupName="content" content={voice1}>
                            <LeftImgContent style={{ paddingLeft: 29 }} />
                        </Chip>
                        <Chip id="230102" type="struct" title="演讲声音2" groupName="content" content={voice2}>
                            <LeftImgContent style={{ paddingRight: 29 }} />
                        </Chip>
                    </div>
                </div>
                <div id="adv_dialog" className={styles.column}>
                    <Chip id="170116" type="struct" title="高端对话导航" groupName="content" content={talkNav}>
                        <ContentNav classname={styles.topTalk} />
                    </Chip>
                    <div className={styles.columnList}>
                        <Chip id="170118" type="struct" title="高端对话1" groupName="content" content={talk1}>
                            <RightImgContent style={{ paddingLeft: 29 }} />
                        </Chip>
                        <Chip id="230103" type="struct" title="高端对话2" groupName="content" content={talk2}>
                            <RightImgContent style={{ paddingRight: 29 }} />
                        </Chip>
                    </div>
                </div>
                <div id="medium_interview" className={styles.column}>
                    <Chip id="170117" type="struct" title="媒体访谈导航" groupName="content" content={mediaNav}>
                        <ContentNav classname={styles.media} />
                    </Chip>
                    <div className={styles.columnList}>
                        <Chip id="170119" type="struct" title="媒体访谈1" groupName="content" content={media1}>
                            <LeftImgContent style={{ paddingLeft: 29 }} />
                        </Chip>
                        <Chip id="170120" type="struct" title="媒体访谈2" groupName="content" content={media2}>
                            <LeftImgContent style={{ paddingRight: 29 }} />
                        </Chip>
                    </div>
                </div>
                <Footer content={footer} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
